import { useAuth } from "../auth/useAuth";

export const useUserToken = () => {
  const auth = useAuth();

  return auth.currentUser?.token ?? undefined;
};
